import { theme } from "@web-noise/core";

const config = {
  min: 0,
  max: 1,
  step: 0.1,
  isVertical: false,
  color: theme.colors.accent2,
  showScale: true,
  scaleSteps: 3,
  size: { height: 80, width: 100 },
};

export default config;
